<div fxLayout="row wrap">
    <div class="premiere-featured-guest"  >

    <h3 class="featured-guest-heading" [ngClass]="symposiums ? 'font': ''">
        Featured Guests
        <hr class="featured-guest-headingHr"> 
    </h3>
    <span class="introduction" *ngIf="eventId">
        Enjoy the exciting Artists of Creatics on the Red Carpet, during Q&A’s, and more.
    </span>
    
    <span class="introduction-symposium-intro" *ngIf="eventid" style="font-family: 'Lato' !important;">
        Enjoy these inspiring presenters. Click on their box to open full bio.
    </span>

</div>

<!-- featured guest-box -->
<div class="drag" *ngIf="show">
<drag-scroll  >
 
    <div drag-scroll-item class="scroll-item">

        <div  class="featured-guest-div" fxLayout="row" fxLayoutGap="5px">
        
            <div class="featured-guest"  *ngFor="let details of mobilePremiereDetails.cinejoyFeaturedGuests" fxLayoutGap="6px">
                
                <div class="featured-guest-image"  fxFlex="">
            
                    <span>
                        
                        <img class="image" src="{{details.img}}"/>
            
                    </span> 
                
                </div>
                
                <div class="featured-guest-info-div dragscroll" fxFlex="90" fxLayout="column"> 
            
                    <h3   class="featured-guest-info">
                        {{details.mainText}} &nbsp; &nbsp; &nbsp; 
                    </h3>

                    <h3 class="introduction">
                        {{details.subText}}
                    </h3> 
                </div>

            </div>
            
        </div>

    </div>
    
</drag-scroll>

</div>
<!-- featured guest-box ended-->

<!-- celebration-feature-guest-box -->
<div class="drag celebration">
    <drag-scroll>
        <div drag-scroll-item class="scroll-items">
            <div class="featured-guest-div" fxLayout="row" fxLayoutGap="5px">
                <div class="featured-guest" *ngFor="let details of mobilePremiereDetails.featuredGuests"
                    fxLayoutGap="6px" (click)="openFeaturedGuestDetails(details)">
                    <div class="featured-guest-image" fxFlex="">
                        <span>
                            <img class="image1" src="{{details.imageUrl}}" />
                        </span>
                    </div>

                    <div class="featured-guest-info-div dragscroll" fxFlex="90" fxLayout="column">
                        <h3 class="featured-guest-info" style="font-family: 'Lato-Bold' !important;">
                            {{details.name}} &nbsp; &nbsp; &nbsp;
                        </h3>
                        <h3 class="introduction" style="font-family: 'Lato-Bold' !important;">
                            {{details.description}}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    </drag-scroll>

    <ng-template #dialogTemplate let-dialogRef="dialogRef" let-data>
        <div fxLayout="column" class="main-container">
        <div class="close-icon-container">
            <button class="close-icon" (click)="dialogRef.close()">
                <i class="bi bi-x-lg" style="font-size: 28px;"></i>
            </button>
        </div>
        <div fxLayout="row" class="custom-dialog-container">
            <div class="guest-image-container">
                <img class="guest-image" src="{{ data.image }}" alt="guest-image">
            </div>
            <div fxFlex="100%" class="flex-column">
                <p style="font-family: 'Lato-Bold' !important;" class="guest-title">{{ data.name }}</p>
                <div *ngIf="data.title?.length > 0 || data.companyName?.length > 0">
                    <ng-container *ngIf="areBothPresent(data.title, data.companyName); else elseBlock">
                        <p style="font-family: 'Lato-Bold' !important;" class="role">{{ data.title }}</p>
                        <p style="font-family: 'Lato-Bold' !important;" class="company">{{ data.companyName }}</p>
                    </ng-container>
                    <ng-template #elseBlock>
                        <p style="font-family: 'Lato-Bold' !important;" class="role">{{ data.title || data.companyName }}</p>
                    </ng-template>
                    <p style="font-family: 'Lato-Bold' !important;" *ngIf="!(data.title?.length > 0 || data.companyName?.length > 0)">
                        <span class="featured-bio">{{ data.bio }}</span>
                    </p>
                    <p *ngIf="data.title?.length > 0 || data.companyName?.length > 0">
                        <span style="font-family: 'Lato-Bold' !important;" class="bio">{{ data.bio }}</span>
                    </p>
                </div>
            </div>
        </div>
        </div>
    </ng-template>

</div>

</div>